import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { InvoiceDetailModel } from '@app/core/models/invoices/invoice-detail.model';
import { InvoiceService } from '@app/core/services/invoice.service';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class InvoiceResolver  {
  constructor(private invoiceService: InvoiceService) {
  }
  resolve(route: ActivatedRouteSnapshot): Observable<InvoiceDetailModel> | Promise<InvoiceDetailModel> | InvoiceDetailModel {
    const id = route.params.id;
    return this.invoiceService.getInvoiceById(id);
  }
}
